{
  "loadFailed": "Tải danh sách tệp thất bại",
  "uploaded": "Đã tải tệp lên",
  "uploadFailed": "Tải tệp lên thất bại",
  "downloadFailed": "Tải tệp xuống thất bại",
  "previewFailed": "Không thể xem trước tệp",
  "cannotPreview": "Không thể xem trước định dạng này. Vui lòng tải xuống.",
  "previewUnavailable": "Không xem trước được định dạng này",
  "deleted": "Đã xóa tệp",
  "deleteFailed": "Xóa tệp thất bại",
  "emptyTitle": "Chưa có tệp nào",
  "emptyDescription": "Tải lên tài liệu hoặc hình ảnh để bắt đầu.",
  "uploadButton": "Tải lên",
  "confirmDeleteTitle": "Xóa tệp?",
  "confirmDelete": "Tệp đã chọn sẽ bị gỡ khỏi danh sách và không còn xem lại được.",
  "columnFile": "Tệp",
  "columnCategory": "Phân loại",
  "columnDescription": "Mô tả",
  "columnUploadDate": "Ngày tải lên",
  "columnSize": "Kích thước",
  "columnActions": "Thao tác",
  "view": "Xem",
  "download": "Tải xuống",
  "delete": "Xóa",
  "selectFile": "Chọn {{name}}",
  "selectedCount": "Đã chọn {{count}} tệp",
  "clearSelection": "Bỏ chọn tất cả",
  "confirmDeleteSelectedTitle": "Xóa {{count}} tệp?",
  "confirmDeleteSelected": "{{count}} tệp đã chọn sẽ bị gỡ khỏi danh sách và không còn xem lại được.",
  "deletePermanently": "Xóa vĩnh viễn",
  "deletedSelected": "Đã xóa {{count}} tệp",
  "bulkDeleteFailed": "Không xóa được {{failed}}/{{total}} tệp",
  "bulkDownloadFailed": "Không tải xuống được {{failed}}/{{total}} tệp",
  "removeFile": "Xóa khỏi danh sách",
  "uploadTitle": "Tải tài liệu lên",
  "supportedFormatsHint": "Định dạng hỗ trợ: PDF, JPG, JPEG, PNG, DICOM",
  "uploading": "Đang tải lên: {{percent}}%",
  "uploadSuccess": "Đã tải tệp lên thành công!",
  "uploadErrorRetry": "Tải tệp lên thất bại. Vui lòng thử lại.",
  "uploadFileFailed": "Tải tệp lên thất bại",
  "uploadPartial": "Đã tải {{ok}}/{{total}} tệp. Lỗi: {{names}}",
  "uploadPartialShort": "Đã tải {{ok}}/{{total}} tệp. {{fail}} tệp thất bại. Vui lòng di chuột vào",
  "uploadAllFailed": "Không tải được {{total}} tệp. Vui lòng di chuột vào",
  "uploadErrorHoverHint": "để xem lý do.",
  "selectFilePrompt": "Nhấn để chọn hoặc kéo thả tệp vào đây",
  "selectFilesPrompt": "Nhấn để chọn một hoặc nhiều tệp",
  "dropTitle": "Chọn tệp hoặc kéo thả vào đây",
  "browseFile": "Chọn tệp",
  "filesSelected": "Đã chọn {{count}} tệp",
  "maxFilesExceeded": "Chỉ được chọn tối đa {{max}} tệp mỗi lần",
  "unsupportedFileType": "Đã bỏ qua 1 tệp không đúng định dạng: {{name}}",
  "unsupportedFileTypes": "Đã bỏ qua {{count}} tệp không đúng định dạng (ví dụ: {{names}})",
  "filterAll": "Tất cả",
  "filterImage": "Hình ảnh",
  "filterDocument": "Tài liệu",
  "filterPhaseAll": "Tất cả tệp",
  "foldersTitle": "Thư mục",
  "treatmentPhaseFoldersTitle": "Giai đoạn điều trị",
  "timeFoldersTitle": "Thời gian",
  "filterTimeAll": "Tất cả thời gian",
  "treatmentPhases": {
    "before": "Trước điều trị",
    "during": "Trong điều trị",
    "after": "Sau điều trị",
    "other": "Khác"
  },
  "galleryFilterEmpty": "Không có tệp nào phù hợp",
  "prevFile": "Tệp trước",
  "nextFile": "Tệp sau",
  "zoomIn": "Phóng to",
  "zoomOut": "Thu nhỏ",
  "rotate": "Xoay",
  "copyImage": "Sao chép ảnh",
  "imageCopied": "Đã sao chép ảnh",
  "copyImageFailed": "Không sao chép được ảnh",
  "today": "Hôm nay",
  "scrollUp": "Cuộn lên",
  "scrollDown": "Cuộn xuống",
  "cancel": "Hủy",
  "upload": "Tải lên"
}
